var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeLibraryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 37,
    height: 37,
    rx: 7,
    fill: "#05F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 9,
    stroke: "#05F",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6757 27.1456H32.1173V20.5373H14.6757V27.1456ZM28.8132 25.4394C29.2645 25.4394 29.6437 25.2859 29.9507 24.979C30.2576 24.672 30.4111 24.2929 30.4111 23.8415C30.4111 23.3901 30.2576 23.0109 29.9507 22.704C29.6437 22.397 29.2645 22.2436 28.8132 22.2436C28.3618 22.2436 27.9826 22.397 27.6757 22.704C27.3687 23.0109 27.2152 23.3901 27.2152 23.8415C27.2152 24.2929 27.3687 24.672 27.6757 24.979C27.9826 25.2859 28.3618 25.4394 28.8132 25.4394ZM34.2298 18.4248H31.2236L29.0298 16.204H17.7632L15.5694 18.4248H12.5632L16.2736 14.7144C16.4722 14.5158 16.6979 14.3623 16.9507 14.254C17.2215 14.1456 17.4923 14.0915 17.7632 14.0915H29.0298C29.3007 14.0915 29.5625 14.1456 29.8152 14.254C30.0861 14.3623 30.3208 14.5158 30.5194 14.7144L34.2298 18.4248ZM14.6757 29.2581C14.0979 29.2581 13.6013 29.0505 13.1861 28.6352C12.7708 28.2199 12.5632 27.7234 12.5632 27.1456V18.4248H34.2298V27.1456C34.2298 27.7234 34.0222 28.2199 33.6069 28.6352C33.1916 29.0505 32.6951 29.2581 32.1173 29.2581H14.6757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeLibraryIcon);
export default __webpack_public_path__ + "static/media/knowledgeLibraryIcon.52397de9c9f65d00b6fbf09e0db10d9b.svg";
export { ForwardRef as ReactComponent };